import type { CartType, FulfillmentType } from '~/utils/types';
import {
  SET_MENU_ITEM_CART_LOCATION_ID,
  SET_SELECTED_SECTION_INDEX,
  SET_SELECTED_SECTION_OFFSET,
  SET_SELECTED_SECTION_SLUG,
  SET_SHOULD_PRELOAD_SECTIONS,
  SET_FOCUS_FIRST_SECTION_ITEM_EFFECT,
  type MenuItemCartAction,
} from './MenuItemCartActions';

export interface MenuItemCartState {
  focusFirstSectionItemEffect: 'active' | 'standby'
  menuItemCartFulfillmentType: Optional<FulfillmentType>;
  menuItemCartLocationId: Optional<number>;
  menuItemCartType: Optional<CartType>;
  selectedSectionIndex: number;
  selectedSectionOffset: number;
  selectedSectionSlug: Optional<string>;
  shouldPreloadSections: boolean;
}

const initialState: MenuItemCartState = {
  focusFirstSectionItemEffect: 'standby',
  menuItemCartFulfillmentType: null,
  menuItemCartLocationId: null,
  menuItemCartType: 'default_cart_type',
  selectedSectionIndex: -1,
  selectedSectionOffset: 0,
  selectedSectionSlug: null,
  shouldPreloadSections: false,
};

const MenuItemCartReducer = (state: MenuItemCartState = initialState, action: MenuItemCartAction): MenuItemCartState => {
  switch (action.type) {
    case SET_MENU_ITEM_CART_LOCATION_ID:
      return {
        ...state,
        menuItemCartLocationId: action.menuItemCartLocationId,
      };
    case SET_SELECTED_SECTION_INDEX:
      return {
        ...state,
        selectedSectionIndex: action.selectedSectionIndex,
      };
    case SET_SELECTED_SECTION_OFFSET:
      return {
        ...state,
        selectedSectionOffset: action.selectedSectionOffset,
      };
    case SET_SELECTED_SECTION_SLUG:
      return {
        ...state,
        selectedSectionSlug: action.selectedSectionSlug,
      };
    case SET_SHOULD_PRELOAD_SECTIONS:
      return {
        ...state,
        shouldPreloadSections: action.shouldPreloadSections,
      };
    case SET_FOCUS_FIRST_SECTION_ITEM_EFFECT:
      return {
        ...state,
        focusFirstSectionItemEffect: action.status,
      };
    default:
      return state;
  }
};

export default MenuItemCartReducer;
